import React from "react";
import BrandImg from "../../assets/login/logo.svg";
import "./BrandLogoTop.css";
const BrandLogoTop = () => {
  return (
    <div className="brand-logo-top">
      <img src={BrandImg} alt="LandBook" />
    </div>
  );
};

export default BrandLogoTop;
